import { Navbar } from "../shared/components/Navbar.js";
import { AuthService } from "../shared/services/AuthService.js";
import { FirebaseService } from "../shared/services/FirebaseService.js";
import { ApiService } from "../shared/services/ApiService.js";
import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import { LocationSelectModule } from "../shared/components/LocationSelectModule.js";
import profileTemplate from "./templates/profile.html?raw";
import changePasswordModalTemplate from "./templates/change-password-modal.html?raw";
import { DocumentViewer } from "./documentViewer.js";
import Swal from "sweetalert2";

let _locationInstance = null;

export const ProfileController = {


	render: async () => {
		try {
			const user = AuthService.getCurrentUser();
			const [vehicleContador, perfilResp, condicionesResp] = await Promise.all([
				ApiService.post("apiapp/ObtenerVehiculosContador", null, user?.token),
				ApiService.post("apiapp/Perfil", null, user?.token),
				ApiService.post("condicionesIVA/obtener/")
			]);

			const perfil = perfilResp.message;

			const docs = perfil.documentacion;

			const data = {
				name: perfil.nombres || "",
				lastName: perfil.Apellido || "",
				email: perfil.email || "",
				celular: perfil.celular || "",
				telefono: perfil.telefono || "",
				document: perfil.documento || "",
				createdAt: new Date(parseInt(perfil.registro.replace(/\D/g, ''), 10)).toLocaleDateString('es-AR'),
				vehicleCount: Number(vehicleContador.vehiculos) || 0,
				QuotesCount: Number(perfil.contPresupuestosTotales) || 0,
				QuotesActiveCount: Number(perfil.contPresupuestosActivos) || 0,
				subscriptionImporte: perfil.planImporte ? perfil.planImporte.toLocaleString() : "",
				subscriptionPlan: perfil.idPlan !== 1 ? "Plan Empresa" : "Plan Personal",
				subscriptionDescription: perfil.idPlan !== 1 ? "Hasta 10 vehículos" : "Hasta 3 vehículos",
				canUpgrade: perfil.idPlan === 1,
				estadoSuscripcion: perfil.estadoSuscripcion || "",
				hasPasswordAuth: FirebaseService.hasPasswordProvider(),
				esEmpresaText: perfil.EsEmpresa ? "Empresa" : "Persona",
				esEmpresaBadge: perfil.EsEmpresa ? "bg-primary" : "bg-info",
				direccion: perfil.direccion || "",
				condicionesIVA: (condicionesResp.message || []).map(c => ({
					id: c.id,
					name: c.nombre,
					selectedAttr: String(c.id) === String(perfil.tipoFiscal) ? "selected" : ""
				})),
			};

			const content = TemplateEngine.render(profileTemplate, data);
			document.getElementById("app").innerHTML = await Navbar.render() + content;

			_locationInstance?.destroy();
			_locationInstance = await LocationSelectModule.mount({
				root: document,
				selectPais: "#selectPais",
				selectProvincia: "#selectProvincia",
				selectLocalidad: "#selectLocalidad",
				placeholderPais: "País",
				placeholderProvincia: "Provincia",
				placeholderLocalidad: "Localidad",
				initial: {
					paisId: perfil.idPais || null,
					provinciaId: perfil.idProvincia || null,
					localidadId: perfil.idLocalidad || null
				}
			});

			document.getElementById("profileForm").addEventListener("submit", ProfileController.updateProfile);

			document.getElementById("btnVerDoc").addEventListener("click", () => {
				DocumentViewer.openDni(docs, ProfileController.render);
			});
			document.getElementById("btnVerLic").addEventListener("click", () => {
				DocumentViewer.openLicencia(docs, ProfileController.render);
			});

			document.getElementById("btnVerOther").addEventListener("click", () => {
				DocumentViewer.openOtros(docs, ProfileController.render);
			});


			if (data.hasPasswordAuth) {
				document.querySelector(".btnChPass").addEventListener("click", async () => {
					await ProfileController.changePassword();
				});
			}

			document.querySelector(".btnVerPrivacidad").addEventListener("click", async () => {
				await ProfileController.privacySettings();
			});

			document.querySelector(".btnDeleteAccount").addEventListener("click", async () => {
				await ProfileController.deleteAccount();
			});

			if (data.canUpgrade) {
				document.querySelector(".btnUpgradePlan").addEventListener("click", async () => {
					await ProfileController.upgradePlan();
				});
			}

		} catch (error) {
			console.error("Error loading profile:", error);
			document.getElementById("app").innerHTML =
				await Navbar.render() +
				`<div class="container mt-4">
          <div class="alert alert-danger">Error al cargar el perfil</div>
        </div>`;
		}
	},

	updateProfile: async (e) => {
		e.preventDefault();
		const formData = new FormData(e.target);
		const profileData = Object.fromEntries(formData);

		try {


			const user = AuthService.getCurrentUser();
			const response = await ApiService.post("apiapp/ActualizarPerfil", {
				persona: {
					Nombres: profileData.name,
					Apellido: profileData.lastName,
					Celular: profileData.celular,
					Telefono: profileData.telefono,
					Direccion: profileData.direccion,
					IdPais: profileData.idPais,
					IdProvincia: profileData.idProvincia,
					IdLocalidad: profileData.idLocalidad,
					TipoFiscal: profileData.idCondicionIVA,
				},
			}, user?.token);

			if (response.status < 1) {
				await Swal.fire("Error", response.message || "No se pudieron actualizar los datos", "error");
				return;
			}


			Swal.fire("Éxito", "Perfil actualizado correctamente", "success");
		} catch (error) {
			Swal.fire("Error", "No se pudo actualizar el perfil", "error");
		}
	},

	changePassword: async () => {
		const result = await Swal.fire({
			title: "Cambiar Contraseña",
			html: changePasswordModalTemplate,
			width: 500,
			showCancelButton: true,
			confirmButtonText: "Cambiar",
			cancelButtonText: "Cancelar",
			didOpen: () => {
				const toggleButtons = document.querySelectorAll(".togPass");
				toggleButtons.forEach(button => {
					button.addEventListener("click", () => {
						ProfileController.togglePassword(button);
					});
				});
			},
			preConfirm: () => {
				const form = document.getElementById("passwordForm");
				const formData = new FormData(form);
				const data = Object.fromEntries(formData);

				if (data.newPassword !== data.confirmPassword) {
					Swal.showValidationMessage("Las contraseñas no coinciden");
					return false;
				}

				return data;
			},
		});

		if (!result.isConfirmed) return;

		// 1. Validar contraseña actual contra Firebase (nunca sale del navegador)
		try {
			await FirebaseService.reauthenticateWithPassword(result.value.currentPassword);
		} catch (error) {
			const isWrongPassword = error?.code === "auth/invalid-credential" || error?.code === "auth/wrong-password";
			await Swal.fire("Error", isWrongPassword ? "La contraseña actual es incorrecta" : "No se pudo verificar la contraseña", "error");
			return;
		}

		// 2. Contraseña actual verificada — enviar solo la nueva al backend
		try {
			const user = AuthService.getCurrentUser();
			const response = await ApiService.post("apiapp/ChangePassword", {
				ClaveNueva: result.value.newPassword,
			}, user?.token);

			if (response.status < 1) {
				await Swal.fire("Error", response.message || "No se pudo cambiar la contraseña", "error");
				return;
			}

			await Swal.fire("Éxito", "Contraseña cambiada correctamente", "success");
		} catch (error) {
			await Swal.fire("Error", "No se pudo cambiar la contraseña", "error");
		}
	},

	togglePassword: (button) => {
		const input = button.previousElementSibling;
		const icon = button.querySelector("i");

		if (input.type === "password") {
			input.type = "text";
			icon.classList.remove("fa-eye");
			icon.classList.add("fa-eye-slash");
		} else {
			input.type = "password";
			icon.classList.remove("fa-eye-slash");
			icon.classList.add("fa-eye");
		}
	},

	privacySettings: async () => {
		await Swal.fire("Privacidad", "Leyenda de los terminos de privacidad", "info");
	},

	upgradePlan: async () => {
		const result = await Swal.fire({
			title: "Mejorar Plan",
			text: "¿Deseas actualizar a Plan Empresa?",
			icon: "question",
			showCancelButton: true,
			confirmButtonText: "Sí, actualizar",
			cancelButtonText: "Cancelar",
		});
		if (!result.isConfirmed) {
			return;
		}

		try {
			const user = AuthService.getCurrentUser();
			const response = await ApiService.post("apiapp/SolicitudUpgrade", null, user?.token);

			if (response.status < 1) {
				await Swal.fire("Error", response.message || "No se pudo realizar la solicitud", "error");
				return;
			}

			Swal.fire("Éxito", "Solicitud enviada. Un asesor se pondrá en contacto contigo.", "success");
		} catch (error) {
			Swal.fire("Error", "No se pudo enviar la solicitud", "error");
		}




	},

	deleteAccount: async () => {
		const result = await Swal.fire({
			title: "¿Estás seguro?",
			text: "Esta acción no se puede deshacer",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sí, eliminar",
			cancelButtonText: "Cancelar",
			confirmButtonColor: "#d33",
		});
		if (result.isConfirmed) {
			alert("Eliminación de cuenta simulada. Aquí iría la llamada a la API.");
			Swal.fire("Eliminado", "Tu cuenta ha sido eliminada... mentiriiiiii", "success");
		}
	},
};
